import React from 'react';
import PropTypes from 'prop-types';

export default function ActionModifyRenderer(props) {
    const {clicked, action1, onEditActionClicked} = props;
    return (
        <>
            <div className={'d-md-block d-sm-none d-none'}>
                { props.data.isEditable && <a className="td-link mr-4" href="#" onClick={()=>onEditActionClicked(props.data)}>{action1}</a> }
            </div>
            <div className={'d-md-none d-sm-block d-block'} style={{textAlign: 'center'}}>
                <a className={'td-link'} href="#responsive">
                    <i className='td-icon-colour-primary td-icon icon-regular  td-icon-all'
                       onClick={() => clicked(props.value)}></i>
                </a>
            </div>
        </>
    );
}

ActionModifyRenderer.propTypes = {
    onActionIconClick: PropTypes.func
}

ActionModifyRenderer.defaultProps = {
    action1: "Edit"
}